module.exports = __webpack_public_path__ + "assets/img/hot_case_monthly_l2.fda46ee7.png";